export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ArticleListItem.vue?vue&type=template&id=3bbae845&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ArticleListItem.vue?vue&type=template&id=3bbae845&scoped=true&
// module id = 178
// module chunks = 0